import Incentives from "./communication-pages/incentives/store";
import Campaigns from "./communication-pages/campaigns/store";

export default {
  namespaced: true,
  modules: {
    Incentives,
    Campaigns,
  },
};
